import { render, staticRenderFns } from "./igt-achievements.vue?vue&type=template&id=9a3023fe&scoped=true&"
import script from "./igt-achievements.vue?vue&type=script&lang=js&"
export * from "./igt-achievements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a3023fe",
  null
  
)

export default component.exports